import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Card,
  Row,
  Col,
  Typography,
  Modal,
  message,
  Space,
  Checkbox,
  Upload,
} from 'antd'
import {
  UserOutlined,
  PhoneOutlined,
  LockOutlined,
  CloudUploadOutlined,
  PlusOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import './Common.module.css'
import styles from './Common.module.css'
import { addUserRequest, getAliOssTokenRequest } from '../api'
import OSS from 'ali-oss'
import { getSixMathRandom } from '../../../../util/handMath'
import { ALI_OSS_PATH } from '../../../../util/constants'
import uploadImg from './upload_picture.svg'
const { TextArea } = Input

let client
let clientExpTime
const AddAccountForm = (props) => {
  const [form] = Form.useForm()
  const [accountStatus, setAccountStatus] = useState(true)
  const [avatar, setAvatar] = useState('')
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    setAvatar('')
    getAliOssToken()
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  },[props.openStatus]) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const onFinish = (values) => {
    console.log('提交的表单数据:', values)
    // 这里可以添加API调用或其他提交逻辑
  }

  const closeCommon = () => {
    props.closeCommonModal()
  }

  function addUser() {
    form.validateFields().then((values) => {
      console.log('表单数据:', values)

      var user_type = '1'
      var name = values.name
      var phone = values.phone
      var pwd = values.pwd
      var status = accountStatus === true ? '1' : '3'

      var beizhu = values.beizhu === undefined ? '' : values.beizhu

      // 调用 API
      addUserRequest(user_type, name, phone, pwd, status, beizhu, (data) => {
        console.log(data)
        if (data.ret === '1') {
          message.success('添加成功', 1)
          props.updateData()
          props.closeCommonModal()
        } else {
          message.error(data.msg, 1)
        }
      })
    })
  }
  function getAliOssToken() {
    let nowDate = new Date().getTime()
    if (!client || nowDate - clientExpTime > 1200000) {
      clientExpTime = new Date().getTime()
      getAliOssTokenRequest((data) => {
        if ('Credentials' in data) {
          client = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: 'oss-cn-qingdao',
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: data.Credentials.AccessKeyId,
            accessKeySecret: data.Credentials.AccessKeySecret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: data.Credentials.SecurityToken,
            refreshSTSToken: async () => {
              // 向您搭建的STS服务获取临时访问凭证。
              getAliOssTokenRequest((data) => {
                return {
                  accessKeyId: data.Credentials.AccessKeyId,
                  accessKeySecret: data.Credentials.AccessKeySecret,
                  stsToken: data.Credentials.SecurityToken,
                }
              })
            },
            // 刷新临时访问凭证的时间间隔，单位为毫秒。
            refreshSTSTokenInterval: 3000000,
            // 填写Bucket名称。
            bucket: 'tgnp',
          })
        }
      })
    }
  }

  function handleChange1(info) {
    getAliOssToken()
    let tempList = info.fileList.map((item, index) => {
      let tempDic = {
        url: item.url,
        uid: item.uid,
        status: item.status,
        name: item.name,
      }
      return tempDic
    })
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  const customRequest = async (options) => {
    const { onSuccess, onError, file } = options

    try {
      // 使用阿里云OSS SDK上传文件
      let timestamp = new Date().getTime()
      let random = getSixMathRandom()
      const result = await client.put(
        ALI_OSS_PATH + 'user/' + timestamp + random + file.name,
        file,
      )
      file.url = result.url.replace('http:', 'https:')
      onSuccess(file)
      changeImgMethod(file.url)
    } catch (e) {
      message.error(`头像上传失败`)
      onError(e)
    }
  }

  function changeImgMethod(url) {
    form.setFieldValue('image_url', url)
    setAvatar(url)
  }

  return (
    <Modal
      maskClosable={false}
      // visible={true}
      open={props.openStatus}
      onCancel={closeCommon}
      footer={null} // 设置 footer 为 null 移除默认按钮
      width={800}
      // className="add-account-container"
    >
      <Card className={styles['form-card']} span={20}>
        <div className={styles['form-title']}>添加应用信息</div>
        <Form
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          className="account-form"
        >
          <Form.Item
            label="应用名称"
            name="appName"
            rules={[{ required: true, message: '请输入应用名称' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input placeholder="请输入应用名称" size="large" />
          </Form.Item>

          <Form.Item
            label="功能介绍"
            name="appDes"
            rules={[{ required: true, message: '请输入功能介绍' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input placeholder="请输入功能介绍" size="large" />
          </Form.Item>

          <Form.Item
            label="跳转链接"
            name="login"
            rules={[{ required: true, message: '请输入跳转链接' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input placeholder="请输入跳转链接" size="large" />
          </Form.Item>
          <Form.Item
            label="应用图标"
            name="appIcon"
            rules={[{ required: true, message: '请输入应用图标' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Upload
              listType="picture"
              fileList={[]}
              onChange={handleChange1}
              customRequest={customRequest}
              accept=".jpg,.png,.jpeg,.svg"
            >
                {avatar==""?<Button type="primary" icon={<UploadOutlined />}>
                上传图标
              </Button>:<img className={styles.uploadButton} src={avatar} />}
              {/* <div className={styles.uploadButton}>
                <PlusOutlined style={{fontSize: 30}} />
                上传图标
              </div> */}
            </Upload>
          </Form.Item>
          <Form.Item
            label="应用状态"
            name="appStatus"
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Switch
              defaultChecked={true}
              onChange={(checked) => {}}
              // checkedChildren="开"
              // unCheckedChildren="关"
              // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
              style={{ marginLeft: 10, marginRight: 10 }}
            />
          </Form.Item>
          <Form.Item
            label="备注"
            name="beizhu"
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <TextArea
              placeholder="输入备注信息"

              // value={tishiValue}
              // onChange={changeTishiFn}
              // readOnly={disableCreate}
            />
          </Form.Item>
          <Form.Item className={styles['form-actions']}>
            <Button
              size="large"
              // onClick={() => form.resetFields()}
              onClick={(e) => {
                // props.cancel()
                closeCommon()
              }}
            >
              取消
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{ marginLeft: 16 }}
            >
              确认
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Modal>
  )
}

export default AddAccountForm
